import { Permission } from '@/shared/permissions';
import { Roles } from '@/shared/roles';
import { ItiString, itiTokenService } from '@/iti-core-vue';

// Cada opción tendrá indicado:
// - el "i18n" con la key para obtener el texto traducido a mostrar
// - ó el "text" con el texto a mostrar (si no se quiere usar multiidioma)
// export const MenuOptions: ItiMenuItem[] = [
export const MenuOptions = [
    {
        icon: 'mdi-home-variant',
        text: ItiString.Empty,
        i18n: 'menu.inicio-privada',
        link: '/main/home',
        permission:  [Roles.Admin, Roles.EntityUser, Roles.ExpertUser],
        children: [],
    },
    {
        icon: 'mdi-earth',
        text: ItiString.Empty,
        i18n: 'menu.inicio-publica',
        link: '/',
        permission:  [Roles.Admin, Roles.EntityUser, Roles.ExpertUser],
        children: [],
    },
    {
        icon: 'mdi-search-web',
        text: ItiString.Empty,
        i18n: 'menu.buscador-avanzado',
        link: '/main/buscador-avanzado',
        permission:  [Roles.Admin, Roles.EntityUser, Roles.ExpertUser],
        children: [],
    },
    /*  {
          icon: 'mdi-tag-multiple',
          text: ItiString.Empty,
          i18n: 'menu.roles',
          link: '/main/roles/lista',
          permission: Permission.updateTemplates,
          children: [],
      },*/
    /* {
         icon: 'mdi-format-list-bulleted',
         text: 'Formulario',
         i18n: ItiString.Empty,
         link: '/main/formulario',
         permission: ItiString.Empty,
         children: [],
     },*/
    {
        icon: 'mdi-tools',
        text: ItiString.Empty,
        i18n: 'menu.administracion',
        link: '',
        permission: ItiString.Empty,
        children: [
            {
                icon: 'mdi-account-group',
                text: ItiString.Empty,
                i18n: 'menu.usuarios',
                link: '/main/users/list',
                permission: [Roles.Admin],
                children: [],
            },
            /* {
                 icon: 'mdi-calendar-check',
                 text: ItiString.Empty,
                 i18n: 'menu.tareas-programadas',
                 link: '/main/tareas-programadas/lista',
                 permission: ItiString.Empty,
                 children: [],
             },*/
            // {
            //     icon: 'category',
            //     text: ItiString.Empty,
            //     i18n: 'maestro-configuracion.categoria',
            //     link: '/',
            //     permission: Permission.updateConfiguration,
            //     children: [
            {
                icon: 'category',
                text: ItiString.Empty,
                i18n: 'maestro-configuracion.categoria-primer-nivel',
                link: '/main/category-first-level/list',
                permission: [Roles.Admin],
                children: [],
            },
            {
                icon: 'category',
                text: ItiString.Empty,
                i18n: 'maestro-configuracion.categoria-segundo-nivel',
                link: '/main/category-second-level/list',
                permission: [Roles.Admin],
                children: [],
            },
            {
                icon: 'category',
                text: ItiString.Empty,
                i18n: 'maestro-configuracion.categoria-tercer-nivel',
                link: '/main/category-third-level/list',
                permission: [Roles.Admin],
                children: [],
            },
            {
                icon: 'category',
                text: ItiString.Empty,
                i18n: 'maestro-configuracion.categoria-cuarto-nivel',
                link: '/main/category-fourth-level/list',
                permission: [Roles.Admin],
                children: [],
            },
            //     ],
            // },
            {
                icon: 'category',
                text: ItiString.Empty,
                i18n: 'maestro-configuracion.codigo-cnae',
                link: '/main/cnae/list',
                permission: [Roles.Admin],
                children: [],
            },
            {
                icon: 'category',
                text: ItiString.Empty,
                i18n: 'maestro-configuracion.codigo-ler',
                link: '/main/ler/list',
                permission: [Roles.Admin],
                children: [],
            },
            {
                icon: 'category',
                text: ItiString.Empty,
                i18n: 'maestro-configuracion.sector',
                link: '/main/sector/list',
                permission: [Roles.Admin],
                children: [],
            },
            {
                icon: 'category',
                text: ItiString.Empty,
                i18n: 'maestro-configuracion.tipo-unidad',
                link: '/main/unit-type/list',
                permission: [Roles.Admin],
                children: [],
            },
            {
                icon: 'category',
                text: ItiString.Empty,
                i18n: 'maestro-configuracion.asociacion',
                link: '/main/association/list',
                permission: [Roles.Admin],
                children: [],
            },
        ],
    },
    {
        icon: 'description',//'mdi-format-list-bulleted',
        text: ItiString.Empty,
        i18n: 'plantillas.listaPlantillas',
        link: '/main/listaPlantillas',
        permission: [Roles.Admin, Roles.ExpertUser],
        children: [],
    },
    {
        icon: 'fas fa-briefcase',
        text: ItiString.Empty,
        i18n: 'collaborative-area.publicArea',
        link: '/main/areasPublicas',
        tooltipi18n: 'menu-tooltip.areas-publicas',
        img: '/assets/img/info.png',
        permission: [Roles.Admin, Roles.EntityUser, Roles.ExpertUser],
        children: [],
    },
    {
        icon: 'fas fa-briefcase',
        text: ItiString.Empty,
        i18n: 'collaborative-area.workGroups',
        link: '/main/gruposTrabajo',
        tooltipi18n: 'menu-tooltip.grupos-trabajo',
        img: '/assets/img/info.png',
        permission: [Roles.Admin, Roles.EntityUser, Roles.ExpertUser],
        children: [],
    },
    {
        icon: 'fas fa-briefcase',
        text: ItiString.Empty,
        i18n: 'collaborative-area.collaborativeAreas',
        link: '/main/areasColaborativas',
        tooltipi18n: 'menu-tooltip.areas-colaborativas',
        img: '/assets/img/info.png',
        permission: [Roles.Admin, Roles.EntityUser, Roles.ExpertUser],
        children: [],
    },
    {
        icon: 'local_offer',
        text: ItiString.Empty,
        i18n: 'offers-demands.myOffersDemands',
        link: '/main/listadoOfertasDemandas',
        permission: [Roles.Admin, Roles.EntityUser, Roles.ExpertUser], 
        children: [],
    },
    {
        icon: 'mdi-alpha',
        text: ItiString.Empty,
        i18n: 'algoritmo.algoritmos',
        link: '/main/listaAlgoritmos',
        permission: [Roles.Admin, Roles.ExpertUser], 
        children: [],
    },
];
